export const selectAuthUser = (state) => state.auth.user
export const selectAuthToken = (state) => state.auth.authToken
